import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SpecimenDealerState {
  specimenDealerDialogOpen: boolean;
  specimenDealerId: null | string;
  specimenDealerUrl: null | string;
  urls: Map<string, string>;
}

const initialState: SpecimenDealerState = {
  specimenDealerDialogOpen: false,
  specimenDealerId: null,
  specimenDealerUrl: null,
  urls: new Map(),
};

export const specimenDealerSlice = createSlice({
  name: "specimenDealer",
  initialState,
  reducers: {
    openSpecimenDealerDialog: (state, action: PayloadAction<string>) => {
      state.specimenDealerDialogOpen = true;
      state.specimenDealerId = action.payload;
      const url = state.urls.get(action.payload);
      if (url) state.specimenDealerUrl = url;
    },
    closeSpecimenDealerDialog: (state) => {
      state.specimenDealerDialogOpen = false;
      state.specimenDealerId = null;
      state.specimenDealerUrl = null;
    },
  },
});

export const { openSpecimenDealerDialog, closeSpecimenDealerDialog } = specimenDealerSlice.actions;

export default specimenDealerSlice.reducer;
